import styled from "styled-components";
import { CustomButton } from "../../../Components/CustomButton/Button";

import "../../../GlobalStyles/Font.css";

export const NameUser = styled.h1`
  font-size: 20px;
  line-height: 1.2;
  font-family: "Exo2 Light";
  color: #000;

  @media (min-width: 744px) {
    display: flex;
    gap: 10px;
    font-size: 24px;
    line-height: 1.1;
  }

  @media (min-width: 1440px) {
    font-size: 36px;
    line-height: 1.19;
  }
`;

export const NicNameUserColor = styled.span`
  color: #1ac63f;
`;

export const ContainerContactUsPage = styled.div`
  @media (min-width: 744px) {
    display: flex;
    flex-direction: row;
  }
`;

export const HeaderContactUsPage = styled.div`
  max-width: 100%;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 20px;

  @media (min-width: 744px) {
    width: 625px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  @media (min-width: 1024px) {
    width: 788px;
    padding: 24px;
  }

  @media (min-width: 1440px) {
    width: 1089px;
  }
`;

export const TitlePage = styled.h1`
  display: none;
  margin-left: auto;
  color: #000;

  @media (min-width: 744px) {
    display: block;
  }
`;

export const ContainerButton = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 16px;

  @media (min-width: 428px) {
    max-width: 396px;
  }

  @media (min-width: 744px) {
    max-width: 348px;
    padding: 24px;
  }

  @media (min-width: 1024px) {
    max-width: 309px;
  }

  @media (min-width: 1440px) {
    max-width: 447px;
  }
`;

export const ButtonMainInfo = styled(CustomButton)`
  width: 100%;
  padding: 18px;
  font-size: 16px;
  line-height: 1.18;
  transition: 450ms cubic-bezier(0.61, 0, 0.51, 1);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  background: #fff;
  color: #000;
  font-family: "Exo2 Medium";
  border-radius: 20px;

  &:hover {
    cursor: pointer;
    transition:
      background 450ms cubic-bezier(0.61, 0, 0.51, 1),
      color 450ms cubic-bezier(0.61, 0, 0.51, 1),
      box-shadow 450ms cubic-bezier(0.61, 0, 0.51, 1);
    background: #1ac63f;
    color: #fff;
    box-shadow: 0px 0px 0px 0px #fff;
  }

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
  }

  @media (min-width: 1024px) {
    width: 309px;
    font-size: 20px;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    width: 447px;
    font-size: 32px;
    line-height: 1.18;
  }
`;

export const ButtonSecurity = styled(CustomButton)`
  width: 100%;
  padding: 18px;
  font-size: 16px;
  line-height: 1.18;
  transition: 450ms cubic-bezier(0.61, 0, 0.51, 1);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  background: #fff;
  color: #000;
  font-family: "Exo2 Medium";
  border-radius: 20px;

  &:hover {
    cursor: pointer;
    transition:
      background 450ms cubic-bezier(0.61, 0, 0.51, 1),
      color 450ms cubic-bezier(0.61, 0, 0.51, 1),
      box-shadow 450ms cubic-bezier(0.61, 0, 0.51, 1);
    background: #1ac63f;
    color: #fff;
    box-shadow: 0px 0px 0px 0px #fff;
  }

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
  }

  @media (min-width: 1024px) {
    width: 309px;
    font-size: 20px;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    width: 447px;
    font-size: 32px;
    line-height: 1.18;
  }
`;

export const Languages = styled(CustomButton)`
  width: 100%;
  padding: 18px;
  font-size: 16px;
  line-height: 1.18;
  transition: 450ms cubic-bezier(0.61, 0, 0.51, 1);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  background: #fff;
  color: #000;
  font-family: "Exo2 Medium";
  border-radius: 20px;

  &:hover {
    cursor: pointer;
    transition:
      background 450ms cubic-bezier(0.61, 0, 0.51, 1),
      color 450ms cubic-bezier(0.61, 0, 0.51, 1),
      box-shadow 450ms cubic-bezier(0.61, 0, 0.51, 1);
    background: #1ac63f;
    color: #fff;
    box-shadow: 0px 0px 0px 0px #fff;
  }

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
  }

  @media (min-width: 1024px) {
    width: 309px;
    font-size: 20px;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    width: 447px;
    font-size: 32px;
    line-height: 1.18;
  }
`;

export const ButtonModes = styled(CustomButton)`
  width: 100%;
  padding: 18px;
  font-size: 16px;
  line-height: 1.18;
  transition: 450ms cubic-bezier(0.61, 0, 0.51, 1);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  background: #fff;
  color: #000;
  font-family: "Exo2 Medium";
  border-radius: 20px;

  &:hover {
    cursor: pointer;
    transition:
      background 450ms cubic-bezier(0.61, 0, 0.51, 1),
      color 450ms cubic-bezier(0.61, 0, 0.51, 1),
      box-shadow 450ms cubic-bezier(0.61, 0, 0.51, 1);
    background: #1ac63f;
    color: #fff;
    box-shadow: 0px 0px 0px 0px #fff;
  }

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
  }

  @media (min-width: 1024px) {
    width: 309px;
    font-size: 20px;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    width: 447px;
    font-size: 32px;
    line-height: 1.18;
  }
`;

export const ButtonLocalData = styled(CustomButton)`
  width: 100%;
  padding: 18px;
  font-size: 16px;
  line-height: 1.18;
  transition: 450ms cubic-bezier(0.61, 0, 0.51, 1);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  background: #fff;
  color: #000;
  font-family: "Exo2 Medium";
  border-radius: 20px;

  &:hover {
    cursor: pointer;
    transition:
      background 450ms cubic-bezier(0.61, 0, 0.51, 1),
      color 450ms cubic-bezier(0.61, 0, 0.51, 1),
      box-shadow 450ms cubic-bezier(0.61, 0, 0.51, 1);
    background: #1ac63f;
    color: #fff;
    box-shadow: 0px 0px 0px 0px #fff;
  }

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
  }

  @media (min-width: 1024px) {
    width: 309px;
    font-size: 20px;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    width: 447px;
    font-size: 32px;
    line-height: 1.18;
  }
`;

export const ButtonContantUs = styled(CustomButton)`
  width: 100%;
  padding: 18px;
  font-size: 16px;
  line-height: 1.18;
  background: #1ac63f;
  color: #fff;
  transition: 450ms cubic-bezier(0.61, 0, 0.51, 1);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  font-family: "Exo2 Medium";
  border-radius: 20px;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
  }

  @media (min-width: 1024px) {
    width: 309px;
    font-size: 20px;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    width: 447px;
    font-size: 32px;
    line-height: 1.18;
  }
`;

export const ButtonCredits = styled(CustomButton)`
  width: 100%;
  padding: 18px;
  font-size: 16px;
  line-height: 1.18;
  transition: 450ms cubic-bezier(0.61, 0, 0.51, 1);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  background: #fff;
  color: #000;
  font-family: "Exo2 Medium";
  border-radius: 20px;

  &:hover {
    cursor: pointer;
    transition:
      background 450ms cubic-bezier(0.61, 0, 0.51, 1),
      color 450ms cubic-bezier(0.61, 0, 0.51, 1),
      box-shadow 450ms cubic-bezier(0.61, 0, 0.51, 1);
    background: #1ac63f;
    color: #fff;
    box-shadow: 0px 0px 0px 0px #fff;
  }

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
  }

  @media (min-width: 1024px) {
    width: 309px;
    font-size: 20px;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    width: 447px;
    font-size: 32px;
    line-height: 1.18;
  }
`;

// Feature page

export const ContainerContactPage = styled.div`
  max-width: 100%;
  padding: 16px;

  @media (min-width: 744px) {
    padding: 16px;
  }

  @media (min-width: 1440px) {
    padding: 24px;
  }
`;

export const TitleContact = styled.h1`
  font-size: 20px;
  line-height: 1.2;
  font-family: "Exo2 Light";
  text-align: center;

  @media (min-width: 744px) {
    display: none;
  }
`;

export const TitleNameBrand = styled.h1`
  font-size: 20px;
  line-height: 1.2;
  font-family: "Exo2 ExtraLight";
  text-align: center;
  margin-top: 23px;

  @media (min-width: 744px) {
    margin-top: 0px;
  }

  @media (min-width: 1024px) {
    font-size: 24px;
    line-height: 1.2;
  }
`;

export const LogoBrand = styled.img`
  width: 100%;
  border-radius: 20px;
  margin-top: 50px;
`;

export const ContainerContantInfo = styled.div`
  display: flex;
  flex-direction: column;
  jusfiny-content: center;
  align-items: center;
  margin-top: 20px;

  @media (min-width: 428px) {
    margin-top: 39px;
  }

  @media (min-width: 744px) {
    margin-top: 30px;
  }

  @media (min-width: 1440px) {
    margin-top: 60px;
  }
`;

export const DescribeText = styled.p`
  font-size: 20px;
  line-height: 1.2;
  font-family: "Exo2 Semibold";

  @media (min-width: 1440px) {
    font-size: 24px;
    line-height: 1.2;
  }
`;

export const EmailSupport = styled.a`
  font-size: 20px;
  line-height: 1.2;
  font-family: "Exo2 Light";
  color: #000;

  @media (min-width: 1440px) {
    font-size: 24px;
    line-height: 1.2;
  }
`;

export const SupportLangsInfo = styled.p`
  font-size: 20px;
  line-height: 1.2;
  font-family: "Exo2 Light";
  text-align: center;
  width: 197px;
  margin-top: 32px;

  @media (min-width: 428px) {
    margin-top: 30px;
  }

  @media (min-width: 744px) {
    width: 247px;
  }
`;
